import React from 'react'
import { mdiMenu, mdiAccountSwitch } from '@mdi/js'
import { CustomTooltip, TooltipPlacementEnum } from 'mp-react-components'
import { IconButton, ListItemIcon, Menu, MenuItem, Divider } from '@mui/material'
import LogoutIcon from '@mui/icons-material/Logout'
import { useAuth } from 'react-oidc-context'
import { useNavigate, useLocation } from 'react-router-dom'
import { useHeaderContext } from '../../contexts/HeaderContext'
import { useAuthContext } from '../../contexts/auth'
import { FotoUsuario } from '../FotoUsuario'
import Icon from '@mdi/react'
import './style.scss'

interface HeaderProps {
  headerTitleProps: {
    href?: string
    logoText?: string
    logoImg?: React.ReactNode
  }
  handleOpenMenu?: () => void
  isOpen?: boolean
}

const Header: React.FC<HeaderProps> = ({
  headerTitleProps: { logoText, logoImg, href = '#' },
  handleOpenMenu,
}: HeaderProps) => {
  const { subHeaderText } = useHeaderContext()
  const { pathname } = useLocation()
  const tituloSecao = pathname === '/consultar-atendimentos' ? 'ATENDIMENTOS'
    : /^\/atendimento\/[^/]+\/?$/.test(pathname) ? 'VISUALIZAR ATENDIMENTO' : subHeaderText
  const { signoutRedirect } = useAuth()
  const { user, switchProfile } = useAuthContext()
  const navigate = useNavigate()
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)

  // Retorna apenas os perfis que não são o perfil ativo
  const getAvailableProfiles = () => {
    if (!user?.profiles || !user?.activeProfile) return []
    return user.profiles.filter(profile => profile.id !== user.activeProfile?.id)
  }

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleProfileSwitch = (profileId: string) => {
    if (switchProfile) {
      switchProfile(profileId)
      handleClose()
      // Adicionar um pequeno delay para garantir que o estado do perfil seja atualizado antes de navegar
      setTimeout(() => {
        navigate('/dashboard')
      }, 100)
    }
  }

  const handleLogout = () => {
    handleClose()
    signoutRedirect()
  }

  return (
    <>
      <header className='header-container'>
        <div className='header-content'>
          <div className='header-left'>
            <button className='bt-header-menu' onClick={handleOpenMenu}>
              <Icon path={mdiMenu} color='#fff' size={1.5} />
            </button>
            <div className='header-logo-container'>
              <a href={href} className='header-logo-a'>
                {logoText ? <h1 className='header-text'>{logoText}</h1> : logoImg}
              </a>
            </div>
          </div>
          <div className='header-right'>
            <div className='header-institution-container'>
              <h2 className='header-institution-text'>SISTEMA DE GESTÃO DE OUVIDORIA</h2>
            </div>

            <div>
              <CustomTooltip text='Menu' placement={TooltipPlacementEnum.BOTTOM}>
                <IconButton
                  onClick={handleClick}
                  size='small'
                  sx={{ ml: 0 }}
                  aria-controls={open ? 'account-menu' : undefined}
                  aria-haspopup='true'
                  aria-expanded={open ? 'true' : undefined}
                >
                  <FotoUsuario />
                </IconButton>
              </CustomTooltip>
            </div>
            {/* Menu de Perfis e Logout */}
            <Menu
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              MenuListProps={{
                'aria-labelledby': 'basic-button',
              }}
              transformOrigin={{ horizontal: 'right', vertical: 'top' }}
              anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
            >
              {/* Lista de Perfis - apenas os que não são o perfil ativo */}
              {getAvailableProfiles().map((profile) => (
                <MenuItem
                  key={profile.id}
                  onClick={() => handleProfileSwitch(profile.id)}
                >
                  <ListItemIcon>
                    <Icon
                      path={mdiAccountSwitch}
                      size={1}
                      style={{ fontWeight: 'bold', strokeWidth: 2 }}
                    />
                  </ListItemIcon>
                  <span style={{ fontWeight: 'bold' }}>{
                    profile.title || profile.name || 'Perfil'
                  }</span>
                </MenuItem>
              ))}

              {/* Divisor se houver perfis alternativos disponíveis */}
              {getAvailableProfiles().length > 0 && (
                <Divider />
              )}

              {/* Opção de Sair */}
              <MenuItem onClick={handleLogout}>
                <ListItemIcon>
                  <LogoutIcon fontSize='small' />
                </ListItemIcon>
                <span style={{ fontWeight: 'bold' }}>Sair</span>
              </MenuItem>
            </Menu>
          </div>
        </div>
        <div className='subHeader'>{tituloSecao?.toLocaleUpperCase()}</div>
      </header>
    </>
  )
}

export default Header
